NtechApp.SingleSelectForm = function(selectForm) {
    this._selectForm = selectForm;

    var me = this;
    this._selectForm.setSelected = function() {
        me.setSelected.apply(me, arguments);
    };

    return this;
};

NtechApp.proto(NtechApp.SingleSelectForm, {
    getFormHtml: function(selectLabel) {
        var html = '';

        html += '<div class="modalForm selectModalForm">';
        html += '   <div class="formHeader">';
        html += '       ' + selectLabel;
        html += '       <div class="close"><div class="button">close</div></div>';
        html += '   </div>';

        html += '   <div class="formContent">';
        html += '       <div class="scrollableFormContent" data-lockMouseWheelScroll="e"></div>';
        html += '   </div>';
        html += '</div>';

        return html;
    },

    afterInsert: function() {
        ; //
    },

    beforeOn: function() {
        ; //
    },

    bindEvents: function() {
        var me = this;
        var click = this._selectForm.getClick();
        var $form = this._selectForm.getForm();

        click.listen($form, ".selectOption", function(event) {
            var $option = $(event.target);
            var val = $option.attr("data-optionValue");

            me.setSelected($option.text(), val);
            me._selectForm.off();

            $(me._selectForm).trigger(NtechApp.SelectForm.EVENT_OPTION_SELECT, [
                $option.text(), val
            ]);
        });
    },

    setSelected: function(label, val, restrictTrigger) {
        var me = this;
        var restrictTrigger = restrictTrigger || false;
        var $selectInputWrapper = this._selectForm.getSelectInputWrapper();
        var $selectInput = this._selectForm.getSelectInput();

        if(!this._selectForm.areLabelUpdatesRestricted())
            $selectInput.val(label);
        //$selectInput.attr("data-selectSelected", val);

        // Custom form select with binded hidden input
        if(NtechApp.dom.hasAttribute($selectInput.get(0), "data-customSelectId")) {
            var hid = $selectInput.attr("data-customSelectId");
            var hattr = "[data-customSelectHiddenId=" + hid + "]";
            var $hiddenSelectInput = $selectInputWrapper.parent().find(hattr);

            $hiddenSelectInput.val(val);
        }

        if(!restrictTrigger)
            $selectInput.trigger("change");
    }
});